import { includes, toLower } from 'lodash';

// Checking if an insurance is of any cash type
export const isCashPaymentType = (payment_type: string | undefined): boolean =>
  typeof payment_type === 'string' && includes(toLower(payment_type), 'cash');

export const doPeriodsOverlap = (
  aStart: string,
  aEnd: string | undefined,
  bStart: string,
  bEnd: string | undefined,
): boolean => {
  const aStartMs = new Date(aStart).getTime();
  const bStartMs = new Date(bStart).getTime();
  const aEndMs = aEnd ? new Date(aEnd).getTime() : Infinity;
  const bEndMs = bEnd ? new Date(bEnd).getTime() : Infinity;

  return aStartMs <= bEndMs && bStartMs <= aEndMs;
};
